import * as moment from 'moment';

enum PromoStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  PAID = 'PAID',
  ENDED = 'ENDED',
}

enum PromoUnitType {
  EXTENDED_TRIAL_MONTHS = 1,
}

type JSONPromo = {
  code: Maybe<string>;
  offer_text: string;
  start_date: string;
  end_date: string;
  status: PromoStatus;
  is_for_new_user: boolean;
  min_qualify_amount?: number;
  min_qualify_units?: number;
  amount?: number;
  max_amount?: number;
  currency?: string;
  percentage?: number;
  max_uses?: number;
  units: number;
  unit_type: number;
};

type Promo = {
  code: Maybe<string>;
  offerText: string;
  startDate: moment.Moment;
  endDate: moment.Moment;
  status: PromoStatus;
  minQualifyAmount?: number;
  minQualifyUnits?: number;
  amount?: number;
  maxAmount?: number;
  currency?: string;
  percentage?: number;
  maxUses?: number;
  isForNewUser?: boolean;
  units: number;
  unitType: PromoUnitType;
};

function fromJSON(jsonPromo: Maybe<JSONPromo>): Maybe<Promo> {
  if (!jsonPromo) return null;

  return {
    code: jsonPromo.code,
    offerText: jsonPromo.offer_text,
    startDate: moment(jsonPromo.start_date),
    endDate: moment(jsonPromo.end_date),
    status: jsonPromo.status,
    minQualifyAmount: jsonPromo.min_qualify_amount,
    minQualifyUnits: jsonPromo.min_qualify_units,
    amount: jsonPromo.amount,
    maxAmount: jsonPromo.max_amount,
    currency: jsonPromo.currency,
    percentage: jsonPromo.percentage,
    maxUses: jsonPromo.max_uses,
    isForNewUser: jsonPromo.is_for_new_user,
    units: jsonPromo.units,
    unitType: jsonPromo.unit_type,
  };
}

function hasExpiration(promo: Promo): boolean {
  const { endDate } = promo;
  return endDate ? endDate.year() < 2035 : false;
}

function isValid(promo: Promo): boolean {
  const { code, endDate } = promo;
  const promoNotExpired = !endDate || new Date() < endDate.toDate();
  return !!(code && promoNotExpired);
}

export default Promo;

export {
  JSONPromo,
  PromoStatus,
  PromoUnitType,
  fromJSON as promoFromJSON,
  hasExpiration as promoHasExpiration,
  isValid as promoIsValid,
};
